import { styled } from '@mui/system';
import { Box, TableContainer } from '@mui/material';
import { motion } from 'framer-motion';

export const VenuesContainer = styled(Box)(() => ({
  width: '100%',
  height: 'calc(100vh - 100px)',
  overflow: 'hidden',
  transition: 'all 0.3s ease-in-out',
}));

export const VenuesContentContainer = styled(TableContainer)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '99%',
  height: 'calc(100vh - 100px)',
  padding: theme.spacing(2),
  borderRadius: '12px',
  backgroundColor: theme.palette.background.default,
}));

export const StyledMotionDiv = styled(motion.div)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '.5rem',
  width: '100%',
}));

export const OperatingHoursContainer = styled(Box)(({ theme }) => ({
  maxWidth: '30rem',
  backgroundColor: theme.palette.background.secondary,
  borderRadius: '8px',
  padding: theme.spacing(2),
}));

export const WeekStartSelector = styled(Box)(({ theme }) => ({
  maxWidth: '30rem',
  backgroundColor: theme.palette.background.secondary,
  borderRadius: '8px',
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  justifyContent: 'space-between',
}));

export const ScheduleList = styled('ul')(() => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
}));

export const ScheduleItem = styled('li')(({ theme, isClosed }) => ({
  display: 'grid',
  gridTemplateColumns: '120px auto auto auto',
  gap: theme.spacing(4),
  padding: theme.spacing(1.5, 0),

  '& .time-element': {
    color: isClosed ? theme.palette.error.main : 'inherit',
  },
}));
